export const NAME = 'OPERATORPAYMENT';

export const FIND = "FIND_" + NAME;
export const FIND_BY_ID = "FIND_BY_ID_" + NAME;
export const CREATE = "CREATE_" + NAME;
export const UPDATE = "UPDATE_" + NAME;
export const DELETE = "DELETE_" + NAME;
export const CHANGE_TABLE = NAME + "_CHANGE_TABLE"
export const SEARCH_TABLE = NAME + "_SEARCH_TABLE"



// WEBPACK FOOTER //
// ./src/views/OperatorPayments/redux/OperatorPaymentsConstants.jsx